import { render } from "./meddraViewer.vue?vue&type=template&id=42873544&scoped=true"
import script from "./meddraViewer.js?vue&type=script&lang=js"
export * from "./meddraViewer.js?vue&type=script&lang=js"

import "./meddraViewer.vue?vue&type=style&index=0&id=42873544&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42873544"]])

export default __exports__